export enum LoanSubType {
    InventoryLoan = 1,
    AcquisitionBridge = 2,
}

const loanSubTypeDescription: string[] = [];
loanSubTypeDescription[LoanSubType.InventoryLoan] = 'Inventory Loan';
loanSubTypeDescription[LoanSubType.AcquisitionBridge] = 'Acquisition Bridge';

export { loanSubTypeDescription };
